import React from "react";
import { Box, Card, CardContent, Typography, Button } from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";

const ShareCopySuccessAlert = ({
  message = "Link copied successfully!",
  onClose,
}) => {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        padding: 2,
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: 320,
          borderRadius: 4,
          textAlign: "center",
          padding: 3,
        }}
        elevation={8}
      >
        <CardContent>

          {/* Share Icon */}
          <ShareIcon
            sx={{
              fontSize: 70,
              color: "primary.main",
              mb: 2,
            }}
          />

          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Success
          </Typography>

          <Typography variant="body2" color="text.secondary" mb={3}>
            {message}
          </Typography>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={onClose}
            sx={{
              borderRadius: 3,
              paddingY: 1,
              fontWeight: 600,
            }}
          >
            Done
          </Button>

        </CardContent>
      </Card>
    </Box>
  );
};

export default ShareCopySuccessAlert;
